import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'compensationFilter',
    standalone: false
})
export class CompensationFilterPipe implements PipeTransform {
	transform(compensations: any[], supplier: string, commodity: string, hasUpfront: boolean): any[] {
		return compensations
			? compensations.filter(
					c =>
						(!supplier || c.supplier === supplier) &&
						(!commodity ||
							(commodity === 'Electricity' && (c.upfront.hasElec || c.upfront50.hasElec || c.residual.hasElec)) ||
							(commodity === 'Natural Gas' && (c.upfront.hasGas || c.upfront50.hasGas || c.residual.hasGas))) &&
						(!hasUpfront || c.upfront.rules?.length || c.upfront50.rules?.length),
				)
			: compensations;
	}
}
